import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ModalHeader from '../../common/Header'
import '../../../styles/Reports/BookingSummaryReport.scss'
import DropDown from '../../common/DropDown'
import CustomDatePicker from '../../common/CustomDatePicker'
import MButton from '../../common/MButton'
import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import { getBookingSummary } from '../../../redux/Report/ReportActions'
import { getTripList, updateShowAlert } from '../../../redux/Actions'
import { isEmpty } from '../../../Utils'
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import BookingSummaryDetails from './BookingSummaryDetails'

const BookingSummaryReport = () => {
    const { userDetails, tripList } = useSelector((state) => state.common);
    const dispatch = useDispatch()
    const [filterValue, setFilterValue] = useState({
        branch: [],
        todate: dayjs(new Date()),
        fromDate: dayjs(new Date()),
        route: [],
        trip: [],
    })
    const [filterOpt, setFilterOpt] = useState({
        trip: []
    })
    const [showReport, setShowReport] = useState(false)
    const [reportData, setReportData] = useState({})

    useEffect(() => {
        if (!isEmpty(userDetails)) {
            const bodyTrip = {
                UserID: userDetails?.UserID,
                CompanyID: userDetails?.CompanyID,
                RouteID: 0,
                ServiceID: 0,
                TripID: 0,
                FromCityID: 0,
                ToCityID: 0
            };
            dispatch(getTripList(bodyTrip))
        }
    }, [userDetails?.CompanyID])

    const handleGenerate = () => {
        setShowReport(false)
        if (filterValue?.route?.length === 0) {
            dispatch(updateShowAlert({
                msg: 'Select Route!',
                open: true,
            }));
        } else if (filterValue?.trip?.length === 0) {
            dispatch(updateShowAlert({
                msg: 'Select Trip!',
                open: true,
            }));
        } else {
            const body = {
                intTripID: filterValue?.trip?.[0]?.TripID || 0,
                dtJourneyFromDate: dayjs(filterValue?.fromDate).format("YYYY-MM-DD"),
                dtJourneyToDate: dayjs(filterValue?.todate).format("YYYY-MM-DD"),
                intLoginUserID: userDetails?.UserID || 0,
            }
            dispatch(getBookingSummary(body)).then((res) => {
                let data = res?.data.APIGetInquiry3ReportDatewiseMAVENResult
                if (data.IsSuccess) {
                    const parsedData = JSON.parse(data.Data);
                    setReportData({
                        Table: parsedData?.Table || [],
                        Table1: parsedData?.Table1 || []
                    });
                    setShowReport(true)
                } else {
                    dispatch(updateShowAlert({
                        msg: data?.ErrorMessage,
                        open: true,
                    }));
                }
            })
        }
    }
    const handleRoute = (val) => {
        let tripOpt = tripList
        if (val?.[0].RouteID !== 0) {
            tripOpt = tripList?.filter((obj) => obj.RouteID === val?.[0]?.RouteID)
        }
        setFilterValue((prev) => ({
            ...prev,
            route: val,
            trip: []
        }))
        setFilterOpt((prev) => ({
            ...prev,
            trip: tripOpt
        }))
    }
    return (
        <Box className='bookingSummarypage'>
            {!showReport ?
                <>
                    <ModalHeader headerText={"Booking Summary Report"} showHamburger={true} />
                    <Box className='filter-section'>
                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>From Date</Typography>
                            </Box>
                            <Box className='datePicker'>
                                <CustomDatePicker
                                    minDate={null}
                                    selectedDate={filterValue?.fromDate}
                                    format='DD-MMM-YYYY'
                                    onChange={(val) => {
                                        if (new Date(val) < new Date(filterValue?.todate)) {
                                            setFilterValue((prev) => ({
                                                ...prev,
                                                fromDate: val
                                            }))
                                        } else {
                                            setFilterValue((prev) => ({
                                                ...prev,
                                                fromDate: val,
                                                todate: val
                                            }))
                                        }
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </Box>
                        </Box>
                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>To Date</Typography>
                            </Box>
                            <Box className='datePicker'>
                                <CustomDatePicker
                                    minDate={filterValue?.fromDate}
                                    selectedDate={filterValue?.todate}
                                    format='DD-MMM-YYYY'
                                    onChange={(val) => {
                                        setFilterValue((prev) => ({
                                            ...prev,
                                            todate: val
                                        }))
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </Box>
                        </Box>

                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>Route</Typography>
                            </Box>
                            <Box className='dropDownFilter'>
                                <DropDown label='Select Route / All Route'
                                    showTopLable={false}
                                    headerLabel='Select Route'
                                    StartIcon={true}
                                    Icon={PeopleIcon}
                                    option={[{ RouteID: 0, RouteName: "All Route" }, ...tripList] || []}
                                    primaryKey='RouteID'
                                    labelKey='RouteName'
                                    preSelectedValues={filterValue?.route || []}
                                    onSelect={handleRoute}
                                />
                            </Box>
                        </Box>
                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>Trip</Typography>
                            </Box>
                            <Box className='dropDownFilter'>
                                <DropDown label='Select Trip / All Trip'
                                    showTopLable={false}
                                    headerLabel='Select Trip'
                                    StartIcon={true}
                                    Icon={PersonIcon}
                                    option={[{ TripID: 0, TripNameLong: "All Trip" }, ...filterOpt?.trip] || []}
                                    primaryKey='TripID'
                                    labelKey='TripNameLong'
                                    preSelectedValues={filterValue?.trip || []}
                                    onSelect={(val) => {
                                        setFilterValue((prev) => ({
                                            ...prev,
                                            trip: val
                                        }))
                                    }}
                                />
                            </Box>
                        </Box>
                        <MButton btnName="Generate" onClick={handleGenerate} />
                    </Box>
                </>
                : <BookingSummaryDetails reportData={reportData} handleBack={() => {
                    setShowReport(false)
                    setReportData({})
                }} />
            }
        </Box>
    )
}

export default BookingSummaryReport